import { dashboardService } from "@/services/api/features/dashboardService";
import { executeAction, executeDownloadAction } from "@/services/api/helpers";

export default {
  namespaced: true,

  state: {
    loading: {},
    error: {},
  },

  getters: {
    isLoading: (state) => (action) => !!state.loading[action],
    getError: (state) => (action) => state.error[action],
  },

  mutations: {
    SET_LOADING(state, { action, status }) {
      state.loading = { ...state.loading, [action]: status };
    },
    SET_ERROR(state, { action, message }) {
      state.error = { ...state.error, [action]: message };
    },
  },
  actions: {
    async getOverallReport({ commit }) {
      return executeAction({ commit, action: "getOverallReport" }, () =>
        dashboardService.getOverallReport()
      );
    },
    async getDashboardStudentList({ commit }, params) {
      return executeAction({ commit, action: "getDashboardStudentList" }, () =>
        dashboardService.getDashboardStudentList(params)
      );
    },
    async getIncomeReport({ commit }, params) {
      return executeAction({ commit, action: "getIncomeReport" }, () =>
        dashboardService.getIncomeReport(params)
      );
    },
    async getMostIncomeCourse({ commit }, params) {
      return executeAction({ commit, action: "getMostIncomeCourse" }, () =>
        dashboardService.getMostIncomeCourse(params)
      );
    },
    async getCourseStatusReport({ commit }, params) {
      return executeAction({ commit, action: "getCourseStatusReport" }, () =>
        dashboardService.getCourseStatusReport(params)
      );
    },
    async getCourseMostStudent({ commit }, params) {
      return executeAction({ commit, action: "getCourseMostStudent" }, () =>
        dashboardService.getCourseMostStudent(params)
      );
    },
    async getExportReportOption({ commit }) {
      return executeAction({ commit, action: "getExportReportOption" }, () =>
        dashboardService.getExportReportOption()
      );
    },
    async getCourseWithStatus({ commit },params) {
      return executeAction({ commit, action: "getCourseWithStatus" }, () =>
        dashboardService.getCourseWithStatus(params)
      );
    },
    async getCourseExportReport({ commit }, params) {
      return await executeDownloadAction(
        { commit, action: "getCourseExportReport" },
        () => dashboardService.getCourseExportReport(params),
        "course_statistic_report.xlsx"
      );
    },
    async getExportStudentListByCourse({ commit }, params) {
      return await executeDownloadAction(
        { commit, action: "getExportStudentListByCourse" },
        () => dashboardService.getExportStudentListByCourse(params),
        "course_studentList_report.xlsx"
      );
    },
  },
};
